<template>
  <div>
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="form-group col-12">
        <w-select :values="templates" :model="$schema.templateId" :disabled="!!id" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <button class="btn btn-primary float-right" @click="submit">
          Dalej
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { wizardStepMixin } from '@/mixins/wizardStep';
import schema from '@/schemas/procedure.schema';

// @vuese
// Krok z podstawowymi danymi procedury
export default {
  mixins: [wizardStepMixin('procedure')],
  schema,
  computed: mapState({
    templates: state => state.template.list.map(template => ({ text: template.name, value: template.id })),
    id: state => state.procedure.id
  }),
  methods: {
    // @vuese
    // Parsuje dane do JSONA przed zapisem
    prepareModel(model) {
      return { ...model, data: model.data && JSON.parse(model.data) };
    }
  }
};
</script>
